import { useQuery } from '@tanstack/react-query';
import { SubRegionClient, SubRegionDTO } from '../services/apiClient';
import { API_BASE_URL, MAX_DROPDOWN_PAGE_SIZE } from '../config/config';
import axiosInstance from '../services/axiosInstance';

const apiClient = new SubRegionClient(API_BASE_URL, axiosInstance);

// Query hook - Get all sub regions for dropdowns (cached 4 hours)
export const useSubRegions = () => {
  return useQuery({
    queryKey: ['subRegions'],
    queryFn: async () => {
      const response = await apiClient.searchSubRegions({
        page: 1,
        pageSize: MAX_DROPDOWN_PAGE_SIZE,
        sortBy: 'Name',
      });
      // See useStateApi.ts — NSwag's ApiResponse_searchResponseDTO_1 codegen collision.
      return (response?.data?.results as SubRegionDTO[] | undefined) || [];
    },
    staleTime: 4 * 60 * 60 * 1000, // 4 hours
    refetchOnReconnect: true,
  });
};
